const SliderViewApartmentPage = () => {
    return(
        <div className="bg-img">
            <section className="breadcumb-area">
                <div className="container h-100">
                    <div className="row h-100 align-items-center">
                        <div className="col-12">
                            <div className="breadcumb-content">
                                <h3 className="breadcumb-title">View Apartment</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
};
export default SliderViewApartmentPage;